import { render, staticRenderFns } from "./DocumentStatusChange.vue?vue&type=template&id=5570e868&"
import script from "./DocumentStatusChange.vue?vue&type=script&lang=js&"
export * from "./DocumentStatusChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports